module.exports = __webpack_public_path__ + "img/load.31464e40.png";